
import { FormComponent } from "../../../utils/enums";

export const addMedicationInventorySchema = {
  name: "addMedicationInventoryForm",
  type: "object",
  properties: {
    medicationName: {
      label: "Medication Name",
      type: "text",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "e.g., Panadol",
      },
    },
    genericName: {
      label: "Generic Name",
      type: "text",
      required: false,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "e.g., Paracetamol",
      },
    },
    dosageForms: {
      label: "Dosage & Form",
      type: "text",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "e.g., 500mg Tablet",
      },
    },
    supplier: {
      label: "Supplier",
      type: "text",
      required: true,
      component: FormComponent.SearchableSelect,
      componentProps: {
        placeholder: "Select a supplier",
      },
    },
    costPerUnit: {
      label: "Cost Per Unit",
      type: "number",
      required: false,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "e.g., 2.50",
        type: "number",
      },
    },
    initialStock: {
      label: "Initial Stock Quantity",
      type: "number",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "e.g., 1000",
        type: "number",
      },
    },
    lotNumber: {
      label: "Lot Number",
      type: "text",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "e.g., BATCH-00123",
      },
    },
    expirationDate: {
      label: "Expiration Date",
      type: "date",
      required: true,
      component: FormComponent.DatePicker,
      componentProps: {
        placeholder: "Select expiration date",
      },
    },
  },
}; 